import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { pricePointDrilldownTableParser } from 'parser/pricePointParser';
import { getThresholdRange } from 'gqlQueries/pricePoint';
const errorMessage: string = 'Something went wrong!';

function useFetchCustomRangeData({ setDefaultPriceRange, setPriceRange, subTileState }: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const { appConfig } = useContext(UserContext);
    const pricePointConfig = getConfig('pricePoint', appConfig);

    const [fetchCustomRangeData, { data: pricePointData, loading: pricePointDataLoading, error: pricePointDataError }] =
        useLazyQuery(getThresholdRange, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPricePointGraphSliderRanges } = payload;
            if (getPricePointGraphSliderRanges) {
                const temp: any = {
                    per_unit: [0, getPricePointGraphSliderRanges?.maxPricePu],
                    per_volume: [0, getPricePointGraphSliderRanges?.maxPricePeq],
                };
                setPriceRange(temp?.[subTileState?.key]);
                setDefaultPriceRange(temp);
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchCustomRangeData: (variables: any) => {
            setLoading(true);
            setData(null);
            setError(null);
            fetchCustomRangeData(variables);
        },
    };
}

export { useFetchCustomRangeData };
